export default __webpack_public_path__ + "media/hero_banner.934f3117.png";